import { Theme } from '@mui/material';
import styled from '@emotion/styled';
import { Link } from "react-router-dom";

type ParamsStyle = {
    theme?: Theme;
    activeselected: string;
}

export const Container = styled.div(`
   width: 100%;
   height: 100vh;
   display: flex;
`);

export const ContainerBody = styled.div(
    ({ theme }: { theme?: Theme }) => `
    width: 100%;
    display: flex;
    flex-direction: column;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        flex-direction: row;
        justify-content: space-between;
    }
`);

export const ContainerNav = styled.div(
    ({ theme }: { theme?: Theme }) => `
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 1.31rem 1.125rem;
        background-color: ${theme?.palette.primary.main};

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            padding: 1rem .7rem 1rem 1rem;
        }

        @media(min-width: ${theme?.breakpoints.values.lg}px) {
            padding: 2rem .36rem 2rem 1.56rem;
        }
`);

export const Footer = styled.footer(
    ({ theme }: { theme?: Theme }) => `
        display: block;
        position: fixed;
        bottom: 0;
        z-index: 1;
        width: 100%;
        height: 4.375rem;
        border-top: 4px solid #97C93D;
        background-color: ${theme?.palette.primary.main};

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            display: none;
        }
`);

export const BoxPerfilImg = styled.div(
    ({ theme, logoperfil }: { theme?: Theme, logoperfil: string }) => `
        width: 4rem;
        height: 4rem;
        border-radius: 100px;
        border: 1.56px solid white;
        background-image: url('${logoperfil}');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 3.1875rem;
            height: 3.1875rem;
        }
`);

export const ListItemButtonCustom = styled(Link)(
    ({ theme, activeselected }: ParamsStyle) => `
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        gap: .5rem;
        height: 2.56rem;
        padding: 0 1.31rem;
        border-bottom: 4px solid transparent;

        &.content-mobile {
            gap: .25rem;
            height: 100%;
            width: fit-content;
            padding: .6rem 4px 0;
            flex-direction: column;
        }

        &[aria-disabled="true"] {
            opacity: .5;
            cursor: not-allowed;
        }
        
        :hover {
            background-color: rgba(10, 168, 227, 0.25);
            border-color: rgba(10, 168, 227, 0.25);

            svg {
                path {
                    fill: #0AA8E3;
                }
            }

            h6 {
                color: #0AA8E3;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            height: 2.4rem;
        }

        @media(min-width: ${theme?.breakpoints.values.lg}px) {
            height: 2.56rem;
        }

        ${activeselected === 'active' && `
            background-color: rgba(10, 168, 227, 0.25);
            border-color: rgba(10, 168, 227, 0.25);

            svg {
                path {
                    fill: #0AA8E3;
                }
            }

            h6 {
                color: #0AA8E3;
            }
        `}
`);